module.exports = __webpack_public_path__ + "static/media/Icon-Cancel.597693a6.svg";